// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"nP-z","inlineTitle":"oP-z","sponsoredAdsWrapper":"pP-z","marketplaceRecosWrapper":"qP-z"};